export const selectCandidates = ({ candidates }) => candidates.candidates
export const selectCurrentCandidate = ({ candidates }) => candidates.currentCandidate
export const selectCandidateJobs = ({ candidates }) => candidates.jobs
